module.exports = __webpack_public_path__ + "app/components/wz/wz.view.html";